import ReactModal from "react-modal";
import {common as strings} from "strings";

import Button from "components/Button";

import styles from "./AlertModal.module.css";

type Props = {
  title: string;
  message: string;
  visible: boolean;
  onClickConfirm: () => void;
  confirmLabel?: string;
};

export default function AlertModal(prop: Props) {
  return (
    <ReactModal
      isOpen={prop.visible}
      className={styles.modal}
      overlayClassName={styles.overlay}
    >
      <h2 className={styles.title}>{prop.title}</h2>
      <span className={styles.message}>{prop.message}</span>
      <Button onClick={prop.onClickConfirm} variant="filled">
        {prop.confirmLabel ?? strings.ok}
      </Button>
    </ReactModal>
  );
}
